import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var VideoRecorderOff = function VideoRecorderOff(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M5 5C3.3432 5 2 6.3431 2 8v8c0 1.6569 1.3432 3 3 3h9c1.3527 0 2.4962-.8952 2.8705-2.1255M17 12l3.6343-3.6343c.4284-.4284.6426-.6426.8265-.657a.5.5 0 0 1 .4194.1737C22 8.0227 22 8.3256 22 8.9314v6.1372c0 .6058 0 .9088-.1198 1.049a.5.5 0 0 1-.4194.1738c-.1839-.0145-.3981-.2287-.8265-.6571zm0 0V9.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C14.7202 5 13.8802 5 12.2 5H9.5M2 2l20 20"
    })
  }));
};
export default VideoRecorderOff;